import React from 'react';
import { Link, useParams } from 'react-router-dom';
import css from '../CreateBudget.module.css';
import PropTypes from 'prop-types';

const StepLink = ({ label, number, toBase, active }) => {
  const params = useParams();
  const to = `${toBase}${
    params.id && !isNaN(params.id) ? `/${params.id}` : ''
  }`;

  return (
    <Link className={`${css.step} ${active ? '' : css.disabled}`} to={to}>
      <div className={`${css.round} ${active ? css.activeB : ''}`}>
        <span className={`${css.stepNumber} ${active ? css.active : ''}`}>
          {number}
        </span>
      </div>
      <h2 className={`${css.stepText} ${active ? css.active : ''}`}>{label}</h2>
    </Link>
  );
};

StepLink.propTypes = {
  label: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  toBase: PropTypes.string.isRequired,
  active: PropTypes.bool,
};

StepLink.defaultProps = {
  active: false,
};

export default StepLink;
